export enum TimeValidityUnit {
  unknown = 'unknown',
  minutes = 'minutes',
  hours = 'hours',
  days = 'days',
  year = 'year',
  semester = 'semester',
  schoolYear = 'schoolyear',
  unlimited = 'unlimited',
}
